import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";

const InfoMerchandising = props => {
	const classes = useStyles();
	const { merchandisingDetail } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				{merchandisingDetail?.name}
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG áp dụng:</Grid>
				<Grid
					classes={{ root: classes.valueTime }}
				>{`${merchandisingDetail?.startTimeRegister} - ${merchandisingDetail?.endTimeRegister}`}</Grid>
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG mua & trưng bày:</Grid>
				<Grid
					classes={{ root: classes.valueTime }}
				>{`${merchandisingDetail?.startTimeMerchandising} - ${merchandisingDetail?.endTimeMerchandising}`}</Grid>
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG trả thưởng:</Grid>
				<Grid
					classes={{ root: classes.valueTime }}
				>{`${merchandisingDetail?.startTimeReward} - ${merchandisingDetail?.endTimeReward}`}</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(InfoMerchandising);
